<template>
  <label
    class="type-body-sm mb-1.5 font-medium"
    :class="props.for ? 'cursor-pointer' : ''"
    :for="props.for"
  >
    <span><slot /></span
    ><span v-if="props.optional" class="text-black/25"> (optional)</span>
  </label>
</template>

<script lang="ts" setup>
interface InputLabelProps {
  for?: string
  optional?: boolean
}

const props = withDefaults(defineProps<InputLabelProps>(), { optional: false })
</script>
